<template lang="pug">
.locations
  select(name="City", v-model="citySelect", @change="cityInput")
    option(value=-1) 全縣市
    option(v-for="city in cityList", :value="city.id") {{ city.name }}
  select(name="Zip", v-model="districtSelect", @change="districtInput")
    option(value=-1) 全區
    option(v-for="district in partialDistrictList", :value="district.id") {{ district.name }}
  span 區域搜尋
</template>

<script>
export default {
  name: "CourseFilter",
  props: {
    cityValue: Number,
    districtValue: Number,
  },
  data() {
    return {
      partialDistrictList: [],
      cityList: [],
      citySelect: this.cityValue,
      districtSelect: this.districtValue,
    };
  },
  watch: {
    districtList() {
      this.updatePartialDistrictList();
    },
    cityValue() {
      this.citySelect = this.cityValue;
      this.updatePartialDistrictList();
    },
    districtValue() {
      this.districtSelect = this.districtValue;
    },
  },
  methods: {
    setCityList(data) {
      this.cityList = data;
    },
    cityInput() {
      this.updatePartialDistrictList();
      this.$emit("update:cityValue", Number(this.citySelect));
      this.districtSelect = -1;
      this.$emit("update:districtValue", Number(this.districtSelect));
    },
    districtInput() {
      this.$emit("update:districtValue", Number(this.districtSelect));
    },
    updatePartialDistrictList() {
      if (this.citySelect != -1 && this.citySelect != undefined) {
        var i;
        this.partialDistrictList = [];
        for (i = 0; i < this.cityList.length; i++) {
          if (this.cityList[i].id == this.citySelect) {
            this.partialDistrictList = this.cityList[i].districts;
            break;
          }
        }
      } else {
        this.partialDistrictList = [];
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/style/locations/course_filter.scss";
</style>
